module.exports = Em.Component.extend({
    classNames: ['todo-list']
})
